import React from "react";
import { useTranslation } from 'next-i18next';

/**
 * ErrorBoxSection
 * 
 * Hiển thị thông báo lỗi với hỗ trợ đa ngôn ngữ.
 * Hỗ trợ cả SSR và client-side rendering.
 * 
 * @param errorKey - Khóa dịch thuật (VD: 'error.invalid_url')
 * @param message - Thông báo lỗi trực tiếp (sẽ được sử dụng nếu không có errorKey)
 */

type ErrorBoxSectionProps = {
  errorKey?: string;
  message?: string;
  className?: string;
};

const ErrorBoxSection: React.FC<ErrorBoxSectionProps> = ({ 
  errorKey, 
  message,
  className = ''
}) => {
  const { t } = useTranslation('common');
  
  // Sử dụng errorKey để lấy bản dịch nếu có, nếu không thì dùng message trực tiếp
  const errorMessage = errorKey ? t(errorKey) : message || t('error.unknown');

  return (
    <section
      className={`w-full max-w-2xl mx-auto mt-8 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-2xl shadow p-5 flex items-center gap-4 ${className}`}
      role="alert"
      aria-live="assertive"
    >
      <svg
        className="w-8 h-8 text-red-500 dark:text-red-400 flex-shrink-0"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01" />
      </svg>
      <span className="text-red-700 dark:text-red-300 font-medium text-base">
        {errorMessage}
      </span>
    </section>
  );
};

export default ErrorBoxSection;
